import { render, staticRenderFns } from "./UserRoles.vue?vue&type=template&id=143b0b8d&scoped=true&"
import script from "./UserRoles.vue?vue&type=script&lang=js&"
export * from "./UserRoles.vue?vue&type=script&lang=js&"
import style0 from "./UserRoles.vue?vue&type=style&index=0&id=143b0b8d&lang=scss&scoped=true&"
import style1 from "./UserRoles.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143b0b8d",
  null
  
)

export default component.exports